import React from 'react';
import { branch, renderComponent } from 'react-recompose';
import Message from '../Message';

export default branch(
  ({ data }) => data && data.error,
  renderComponent(({ data }) => (<Message error header="Oops, something went wrong" content={data.error.message} />)),
);
